import { render, staticRenderFns } from "./OtherOfficeFacilitiesTable.vue?vue&type=template&id=1afa50d5&scoped=true&lang=pug"
import script from "./OtherOfficeFacilitiesTable.vue?vue&type=script&lang=ts"
export * from "./OtherOfficeFacilitiesTable.vue?vue&type=script&lang=ts"
import style0 from "./OtherOfficeFacilitiesTable.vue?vue&type=style&index=0&id=1afa50d5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1afa50d5",
  null
  
)

export default component.exports